import http from "./http_common";

const saveReminder = (data) => {
  return http.post("/patientMedicationReminder/batch/save", data);
};

const updateReminder = (data) => {
  return http.put("/patientMedicationReminder/batch/update", data);
};

const listReminders = (data) => {
  return http.get("/patientMedicationReminder/list/filter", data);
};

const MedicineReminderService = {
  saveReminder,
  updateReminder,
  listReminders,
};

export default MedicineReminderService;
